<template>
  <div>
    <template v-for="item in routes">
      <router-link v-if="hasPermission(item) && !item.hidden&&item.noDropdown&&item.children.length>0" :to="item.path+'/'+item.children[0].path">
        <el-menu-item :index="item.path+'/'+item.children[0].path">
          <icon-svg v-if='item.icon' :icon-class="item.icon" /> {{item.name}}
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.name" v-if="hasPermission(item) && !item.noDropdown&&!item.hidden">
        <template slot="title">
          <icon-svg v-if='item.icon' :icon-class="item.icon" /> {{item.name}}
          <el-badge :value="auditShopInfo" :hidden="item.name !== '门店管理'"> </el-badge>
        </template>
        <template v-for="child in item.children" v-if='hasPermission(child) && !child.hidden'>
          <sidebar-item class='menu-indent' v-if='child.children&&child.children.length>0' :routes='[child]'> </sidebar-item>
          <router-link v-else class="menu-indent" :to="item.path+'/'+child.path">
            <el-menu-item :index="item.path+'/'+child.path">
              {{child.name}}
              <!-- <el-badge  is-dot :hidden="child.name !== '内容审核'" v-if="!!examineRemind"> </el-badge> -->
              <el-badge :value="auditShopInfo" :hidden="child.name !== '门店管理'"> </el-badge>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(['examineRemind', 'auditShopInfo', 'permissions'])
  },
  methods: {
    hasPermission(item) {
      if (item.meta && item.meta.permission) {
        const perms = this.permissions || [];
        return perms.includes(item.meta.permission);
      }
      return true;
    }
  },
  mounted: function() {
    console.log(this.routes, '处理理由')
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.svg-icon {
  margin-right: 10px;
}
.hideSidebar .menu-indent{
  display: block;
  text-indent: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/SidebarItem.vue?41a81f90